import { getApolloClient } from 'owa-apollo';
import {
    CreateCalendarDocument,
    CreateCalendarMutation,
    CreateCalendarMutationVariables,
} from '../graphql/__generated__/createCalendarMutation.interface';

export type CreateCalendarResult = CreateCalendarMutation['createCalendar'];

export async function createCalendarService(
    input: CreateCalendarMutationVariables
): Promise<CreateCalendarResult> {
    const client = await getApolloClient();
    const mutationResult = await client.mutate({
        variables: input,
        mutation: CreateCalendarDocument,
    });

    return mutationResult?.data?.createCalendar;
}
